import { defineComponent as r, createElementBlock as n, openBlock as o, renderSlot as t } from "vue";
const l = ["href"], p = /* @__PURE__ */ r({
  __name: "HelpfulLink",
  props: {
    href: {}
  },
  setup(s) {
    return (e, f) => (o(), n("a", {
      class: "decoration-c-3 cursor-help underline underline-offset-2",
      href: e.href,
      rel: "noopener noreferrer",
      target: "_blank"
    }, [
      t(e.$slots, "default")
    ], 8, l));
  }
});
export {
  p as default
};
